// OneDesk360 Global Design Tokens — single source of truth for components.
// Use these instead of Tailwind's default semantic palette so the design
// system stays decoupled from shadcn defaults.
export const OD = {
  color: {
    primary: "#0F172A",
    secondary: "#64748B",
    success: "#10B981",
    warning: "#F59E0B",
    danger: "#EF4444",
    bg: "#F8FAFC",
    card: "#FFFFFF",
    border: "#E2E8F0",
    textPrimary: "#0F172A",
    textSecondary: "#64748B",
  },
  radius: { card: "16px", btn: "12px", input: "10px" },
  shadow: { subtle: "0 1px 2px 0 rgba(15, 23, 42, 0.05)" },
  // Allowed spacing: 8, 12, 16, 24, 32 px (Tailwind 2/3/4/6/8).
  space: { xs: 8, sm: 12, md: 16, lg: 24, xl: 32 },
};

// Tailwind class shortcuts — keep components DRY.
export const cardCls =
  "bg-onedesk-card border border-onedesk-border rounded-od-card shadow-od-subtle";
export const labelCls =
  "text-xs font-bold uppercase tracking-wider text-onedesk-textSecondary";
export const headingCls = "font-bold text-onedesk-textPrimary";
export const bodyCls = "font-medium text-onedesk-textSecondary";
